import type { RuntimeConfig } from "#app"
import { replaceUrlS3Helper } from "~/scripts/useful-functions"

export function replaceUrlS3(url: string | null, config: RuntimeConfig) {
  return replaceUrlS3Helper(url, config.cdnUrl, config.graphqlEndpoint)
}
